import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import GlassCard from "../../../components/common/GlassCard";

function ProceduresCard({ procedures, onAddProcedure, onOpenLookup, onDeleteProcedure }) {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [activeProcedureId, setActiveProcedureId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setMenuAnchor(event.currentTarget);
    setActiveProcedureId(id);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setActiveProcedureId(null);
  };

  return (
    <GlassCard
      title="Recent Procedures"
      addLabel="Add Procedure"
      icon={<LocalHospitalIcon color="primary" />}
      onAdd={onAddProcedure}
      onLookup={onOpenLookup}
      lookupLabel="CPT Lookup"
    >
      {procedures?.length ? (
        procedures.map((proc) => (
          <Box
            key={proc.id}
            mb={1}
            sx={{
              p: 1,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "background.paper",
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box flex={1}>
                <Typography variant="body2" fontWeight={500}>
                  {proc.procedure_name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {proc.procedure_code} • Dr. {proc.provider}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                  {proc.procedure_date} • {proc.status}
                </Typography>
              </Box>
              <Tooltip title="Options">
                <IconButton size="small" onClick={(e) => handleMenuOpen(e, proc.id)} aria-label="Procedure options menu">
                  <MoreVertIcon aria-label="Procedure options menu" fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          No procedures
        </Typography>
      )}

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            if (activeProcedureId) {
              onDeleteProcedure(activeProcedureId);
            }
          }}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Delete
        </MenuItem>
      </Menu>
    </GlassCard>
  );
}

ProceduresCard.propTypes = {
  procedures: PropTypes.array,
  onAddProcedure: PropTypes.func.isRequired,
  onOpenLookup: PropTypes.func.isRequired,
  onDeleteProcedure: PropTypes.func.isRequired,
};

ProceduresCard.defaultProps = {
  procedures: [],
};

export default ProceduresCard;
